import { MyReferralPartnerResponse } from "../contracts/MyReferralPartnerResponse";
import { MyPartnerStatus } from "../models/MyPartnerStatus";

export const mapResponseToMyPartnerStatus = (
  response: MyReferralPartnerResponse
): MyPartnerStatus => ({
  isPartner: response.isPartner,
  termsAccepted: response.termsAccepted,
  code: response.code,
  acceptanceToken: response.acceptanceToken,
  referralCount: response.referralCount,
  convertedCount: response.convertedCount,
  unpaidAmountMinorUnits: response.unpaidAmountMinorUnits,
  paidAmountMinorUnits: response.paidAmountMinorUnits,
  bountyAmountMinorUnits: response.bountyAmountMinorUnits,
  bountyCurrency: response.bountyCurrency,
  payoutThresholdMinorUnits: response.payoutThresholdMinorUnits,
  trialExtensionDays: response.trialExtensionDays,
});
